import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

export default class SelectFieldFilter extends React.Component {
  render(){
    const { onChange, value, symbol, options, fieldName, accessor = 'percent_change'} = this.props;
    const percentFilter = fieldName === accessor;
    return (
      <select
        value={value}
        onChange={event => {
          onChange(event.target.value, accessor);
        }}
      >
      {options.map(value => {
        return (
          <option key={value} value={value} >
            { percentFilter ? value + symbol : value }
          </option>
        );
      })}
      </select>
    )
  }
}
